import React from 'react';

import Text from '../Text';
import Locale from '../../Translate/Locale';

import UploadIcon from '../../../icons/upload.svg';

import styles from './Invitation.scss';

type Props = {
  children: string;
};

function Invitation(props: Props) {
  return (
    <div className={styles.container}>
      <UploadIcon className={styles.icon} />
      <Text className={styles.text}>
        <Locale>{props.children}</Locale>
      </Text>
    </div>
  );
}

export default React.memo(Invitation);
